var _g, _g2, _g3, _g4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectionEnterprise1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1734_4339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 0,
    width: 18,
    height: 80
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9b2c71ceb4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.3389 0H48.3803V80H31.3389V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1734_4339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.9928 80C35.5352 80 31.9307 76.3955 31.9307 71.9379V8.06213C31.9307 3.60454 35.5352 0 39.9928 0C44.4504 0 48.0549 3.60454 48.0549 8.06213V71.9379C48.0549 76.3782 44.4504 80 39.9928 80Z",
    fill: "#D7D3F7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1734_4339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 31,
    width: 80,
    height: 18
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "2830e273c8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 31.605H80V48.6464H0V31.605Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1734_4339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 39.9925C0 35.535 3.60454 31.9304 8.0646 31.9304H71.9379C76.3955 31.9304 80 35.535 80 39.9925C80 44.4501 76.3955 48.0547 71.9379 48.0547H8.0646C3.60454 48.0547 0 44.4501 0 39.9925Z",
    fill: "#D7D3F7"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.7166 68.284C8.56322 65.1307 8.56322 60.0296 11.7166 56.891L56.8744 11.716C60.0302 8.56261 65.1313 8.56261 68.2698 11.716C71.4232 14.8693 71.4232 19.9729 68.2698 23.1114L23.112 68.284C19.9562 71.4226 14.8551 71.4226 11.7166 68.284Z",
    fill: "#D7D3F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.7166 11.716C14.8724 8.56261 19.9735 8.56261 23.112 11.716L68.2698 56.891C71.4232 60.0444 71.4232 65.1455 68.2698 68.284C65.114 71.4374 60.0129 71.4374 56.8744 68.284L11.7166 23.1114C8.56322 19.9729 8.56322 14.8693 11.7166 11.716Z",
    fill: "#D7D3F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionEnterprise1);
export default __webpack_public_path__ + "static/media/icon-section-enterprise-1.d071b83181d4982389aa3c787f6b8f7df3ae9134a164e672b579048406074c65.svg";
export { ForwardRef as ReactComponent };